import { Grid } from '@material-ui/core';
import { EntityLayout, EntityLinksCard } from '@backstage/plugin-catalog';
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { EntityWarningContent } from './EntityWarningContent';
import { techdocsContent } from './TechdocsContent';

export const GroupEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <EntityWarningContent />
        <Grid item xs={12} md={6}>
          <Grid container>
            <Grid item xs={12}>
              <EntityGroupProfileCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMembersListCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container>
            <Grid item xs={12}>
              <EntityLinksCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMarkdownCard />
            </Grid>
            <Grid item xs={12}>
              <EntityOwnershipCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);
